import KeycloakService from './keycloakService';
import { TypeNotification, useGlobalStore } from '@/store/globalStore';
// @ts-ignore
import SrhUiI18nService from 'srh-ui/dist/services/i18n';
import { UseStoreCategory } from '@/store/categoryStore';
import { HTTPMethods, callApi } from '@/utils/api';
import { getApiUrl } from '@/utils/url';

export default {
  async loadCategory() {
    const i18n = new SrhUiI18nService();
    const { t } = i18n.getI18nInstance().global;

    const globalStore = useGlobalStore();

    try {
      await KeycloakService.CallUpdate().then(async () => {
        const categoryStore = UseStoreCategory();
        const config = {
          'Content-Type': 'application/json',
        };

        await callApi({
          path: `${getApiUrl()}/srh4u/api/category`,
          method: HTTPMethods.POST,
          body: {},
          options: config,
          errorMessage: '',
          successCallback: (result: any) => {
            categoryStore.clearCategory();
            result.forEach(async (element: any) => {
              await categoryStore.setCategory(element);
            });
          },
          // Removed errorMessage to let the catch block control notifications
        });
      });
    } catch (e: any) {
      if (e?.statusCode !== 403) {
        globalStore.showNotification(
          TypeNotification.ERROR,
          t('errors.unknown'),
          t('errors.title')
        );
      }

      // Optional: console.warn('403 Forbidden (category):', e.message);
    }
  },
};
